import { getElement } from '../utils/functional'
import { getOffsetTop, scrollToY } from '../utils/index'

export default class scrollToProductInfo {
  constructor (el) {
    this.els = {
      el,
      info: getElement('[data-section="product-info"]')
    }

    this.els.el.addEventListener('click', e => {
      e.preventDefault()

      scrollToY(getOffsetTop(this.els.info))
    })
  }
}
